import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DateService } from '@rd/core/services/date/date.service';
import { DomService } from '@rd/core/services/dom/dom.service';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogConfig } from '@rd/popup/dialog-config';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'rd-auto-redemption-date-picker-dialog',
  templateUrl: './date-picker-dialog.component.html',
  styles: [
    `
      :host ::ng-deep .datepicker-container {
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AutoRedemptionDatePickerDialogComponent
  implements OnInit, OnDestroy
{
  @HostBinding('class.rd-auto-redemption-date-picker-dialog')
  componentClass = true;

  minDate = this.dateService.toUTCDateWithOffset(
    this.dateService.dayjs().add(1, 'day').toDate(),
  );
  maxDate = this.dateService.toUTCDateWithOffset(
    this.dateService.dayjs().add(1, 'year').toDate(),
  );

  dateControl = new UntypedFormControl(
    this.dialogConfig.data?.inputDate || this.minDate,
  );

  close = new EventEmitter();
  destroy$ = new Subject<void>();

  constructor(
    private domService: DomService,
    private dateService: DateService,
    public dialogConfig: DialogConfig<{
      inputDate: Date;
      onSubmit(date: Date): void;
      onClose(): () => void;
    }>,
    private iconRegistryService: IconRegistryService,
  ) {}

  ngOnInit(): void {
    this.iconRegistryService.registerIcon('close');
    this.close
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.dialogConfig.data?.onClose()),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeDialog(): void {
    this.dialogConfig.data?.onClose();
    this.domService.unlockBody();
  }

  submitDateClick(): void {
    this.dialogConfig.data?.onSubmit(this.dateControl.value);
    this.closeDialog();
  }

  cancelClick(): void {
    this.closeDialog();
  }
}
